import { render } from "./taskInfo.vue?vue&type=template&id=27759e58&scoped=true"
import script from "./taskInfo.vue?vue&type=script&lang=ts"
export * from "./taskInfo.vue?vue&type=script&lang=ts"

import "./taskInfo.vue?vue&type=style&index=0&id=27759e58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27759e58"

export default script